import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Document, DocumentWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateDocument(): UseMutationResult<
  AxiosResponse<Document>,
  AxiosError<ErrorMessage>,
  DocumentWrite
> {
  const queryClient = useQueryClient();

  const updateDocument = useCallback((document: DocumentWrite): Promise<AxiosResponse<Document>> => {
    return client.put(`documents/${document.documentId}/`, document);
  }, []);

  return useMutation(updateDocument, {
    onSuccess: () => {
      queryClient.invalidateQueries('documents');
    },
  });
}
